const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

/** Single in-flight POST /refresh; concurrent 401s share one refresh. */
let refreshInFlight = null;

function refreshSession() {
  if (!refreshInFlight) {
    refreshInFlight = fetch(`${API_BASE_URL}/refresh`, {
      method: "POST",
      credentials: "include",
    }).finally(() => {
      refreshInFlight = null;
    });
  }
  return refreshInFlight;
}

function redirectToLogin() {
  if (window.location.pathname === "/login") return;
  window.location.replace("/login");
}

/**
 * Session-aware fetch: always sends cookies. On 401, runs one shared POST /refresh,
 * then retries the original request once. Refresh failure or second 401 → /login
 * (unless redirectOnAuthFailure is false — used by the route guard).
 *
 * @param {RequestInfo} input
 * @param {RequestInit & { _authRetry?: boolean, redirectOnAuthFailure?: boolean }} [init]
 */
export async function authenticatedFetch(input, init) {
  const { _authRetry, redirectOnAuthFailure = true, ...rest } = init ?? {};
  const mergedInit = {
    ...rest,
    credentials: "include",
  };

  const response = await fetch(input, mergedInit);

  if (response.status !== 401) {
    return response;
  }

  if (_authRetry) {
    if (redirectOnAuthFailure) redirectToLogin();
    return response;
  }

  const refreshRes = await refreshSession();

  if (!refreshRes.ok) {
    if (redirectOnAuthFailure) redirectToLogin();
    return response;
  }

  return authenticatedFetch(input, {
    ...(init ?? {}),
    _authRetry: true,
    credentials: "include",
  });
}
